import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';
import { FAST_TIMER } from '~/const/timers';
import ProductCard from '~/components/molecules/Global/ProductCard.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/night-light.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/technical-problem.svg';

var MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'AddToCartModal',
  components: {
    MdmModal,
    ProductCard
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    isCrossProductExist: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      quantity: 1,
      show: false,
      btnDisabled: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    items: 'cart/items',
    successServer: 'cart/successServer'
  })), {}, {
    productName() {
      return this.product.line ? "".concat(this.product.line, " - ").concat(this.product.name) : this.product.name;
    },

    cartUrl() {
      return this.buildCartUrl(this.locale);
    },

    quantityTracking() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_quantite',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    }

  }),
  watch: {
    showModal() {
      if (this.showModal && this.items) {
        var items = this.items.filter(e => e.productReference === this.product.reference);

        if (items.length > 1) {
          this.quantity = items.find(e => e.offer === this.product.offer).quantity || 1;
        } else {
          this.quantity = items[0].quantity || 1;
        }
      }
    }

  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    updateCart: 'cart/update'
  })), {}, {
    scrollToNextProducts() {
      var positionNextFirstProduct = document.querySelector('#section-xsell-eb');

      if (positionNextFirstProduct) {
        window.scrollTo({
          top: positionNextFirstProduct.offsetTop - positionNextFirstProduct.offsetHeight / 4,
          behavior: 'smooth'
        });
      }

      this.$emit('onclosemodal');
    },

    debounceUpdateQty: debounce(function updateCartQuantity(event) {
      this.updateCart({
        reference: this.product.reference,
        offer: this.product.offer,
        quantity: this.quantity
      }).then(() => {
        this.btnDisabled = false;
      });
      this.trackQuantityChange(event);
    }, FAST_TIMER),

    decrementQuantity() {
      if (parseInt(this.quantity, 10) <= 1) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) - 1;
    },

    incrementQuantity() {
      if (parseInt(this.quantity, 10) >= 30) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) + 1;
    },

    trackQuantityChange(event) {
      this.$root.$emit('generic-tracking', event, this.quantityTracking);
    }

  })
};